import React, { useContext, useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { Button, Col, Container, Form, FormFeedback, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import Swal from 'sweetalert2';
import classnames from 'classnames';
import { GolbalDataContext } from '../../components/store/global-data-provider';
import ConfigData from "../../config.json";
import StepWorkflow from '../../components/common/step-workflow';
import { IconAlertError, IconAlertSuccess, IconDuplicateEmail, IconLoading } from '../../components/common/popup-alert';
import AssignDetailCsa from '../../components/assign/assign-detail-csa';
import AssignDetailNda from '../../components/assign/assign-detail-nda';
import AssignDetailLdr from '../../components/assign/assign-detail-ldr';
import AssignDetailDbd from '../../components/assign/assign-detail-dbd';
import AssignDetailPoa from '../../components/assign/assign-detail-poa';
import RequestHistory from '../../components/request/request-history';

const PrefinalContractUser = () => {
    const { id } = useParams();
    const history = useHistory();
    const { changeTitlePage } = useContext(GolbalDataContext);
    const [customActiveTab, setcustomActiveTab] = useState("2");
    const [dataRequestDetail, setDataRequestDetail] = useState([]);
    const [dataRequestFormDetail, setDataRequestFormDetail] = useState([]);
    const [dataRequestHistory, setDataRequestHistory] = useState([]);
    const [formIsDisabled, setFormIsDisabled] = useState(false);
    const [dataRequest, setDataRequest] = useState({
        "id": 0,
        "request_no": "",
        "select_legal_approve_by": "",
        "legal1_approve_by": "",
        "legal2_approve_by": "",
        "legal3_approve_by": "",
        "select_user_approve_by": "",
        "user1_approve_by": "",
        "user2_approve_by": "",
        "user3_approve_by": "",
        "note": "",
        "send_to": ""
    });
    const englishEmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    useEffect(() => {
        changeTitlePage("All Request");
        let strId = "0";
        try{
            strId = atob(id);
        }catch(error){
            strId = "0";
        }
        LoadUserCanDoReq(strId);
    }, []);

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: dataRequest.id || 0,
            request_no: dataRequest.request_no || "",
            select_legal_approve_by: dataRequest.select_legal_approve_by || "",
            legal1_approve_by: dataRequest.legal1_approve_by || "",
            legal2_approve_by: dataRequest.legal2_approve_by || "",
            legal3_approve_by: dataRequest.legal3_approve_by || "",
            select_user_approve_by: dataRequest.select_user_approve_by || "",
            user1_approve_by: dataRequest.user1_approve_by || "",
            user2_approve_by: dataRequest.user2_approve_by || "",
            user3_approve_by: dataRequest.user3_approve_by || "",
            note: dataRequest.note || "",
            send_to: dataRequest.send_to || "",
        },
        validationSchema: Yup.object({
            // user1_approve_by: Yup.string().required("Please enter a approver 1"),
            user1_approve_by: Yup.string().email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
            user2_approve_by: Yup.string().email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
            user3_approve_by: Yup.string().email("Please enter a Email Address.").matches(englishEmailRegex, "Email must be a valid English email address"),
        }),
        onSubmit: (values) => {
            // console.log(values);
            // console.log(fileLegalFinalDoc);
            SavePreFinalContactUser(values);
        }
    });

    const OnClickBack = () => {
        // history.push("/dashboard");
        history.push(GetUrlBack());
    };

    const toggleCustomActiveTab = (tab) => {
        if (customActiveTab !== tab) {
            setcustomActiveTab(tab);
        }
    };

    const showLoading = (isShow) => {
        if (isShow) {
            Swal.fire({
                iconHtml: IconLoading,
                title: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                    Swal.showLoading();
                },
            });
        } else {
            Swal.close();           
        }
    };

    const SwitchRequestDetail = () => {
        switch (dataRequestDetail.table_name?.toLowerCase()) {
            case "csa": 
                return (
                    <AssignDetailCsa 
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "nda": 
                return (
                    <AssignDetailNda
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "ldr": 
                return (
                    <AssignDetailLdr
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "dbd": 
                return (
                    <AssignDetailDbd
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            case "poa": 
                return (
                    <AssignDetailPoa
                        requestDetail={dataRequestDetail}
                        requestTemplateDetail={dataRequestFormDetail}
                    />
                );
            default: 
                return (
                    <div></div>
                );
        }
    };

    const GetUrlBack = () => {
        const urlBack = (dataRequestDetail.table_name !== "" && dataRequestDetail.table_name !== null && dataRequestDetail.table_name !== undefined) ? "/request-form/" + btoa(dataRequestDetail.table_name) : "/all-type-request";
        return urlBack;
    };

    const SetAndCheckEmail = (inputValue, inputName) => {
        // console.log(validation.values.legal1_approve_by, validation.values.legal2_approve_by, validation.values.legal3_approve_by);
        const objApproveBy = { 
            "legal1_approve_by": validation.values.legal1_approve_by,
            "legal2_approve_by": validation.values.legal2_approve_by,
            "legal3_approve_by": validation.values.legal3_approve_by,
            "user1_approve_by": validation.values.user1_approve_by,
            "user2_approve_by": validation.values.user2_approve_by,
            "user3_approve_by": validation.values.user3_approve_by
        };
        const updatedForm = { ...objApproveBy, [inputName]: inputValue };
        const values = Object.values(updatedForm).filter((v) => v !== ""); // กรองค่าว่าง
        const uniqueValues = new Set(values);

        if(values.length !== uniqueValues.size){
            validation.handleChange(inputName)("");
            Swal.fire({
                iconHtml: IconDuplicateEmail,
                title: "ผู้อนุมัติท่านนี้ ได้ถูกเลือกแล้ว\nThis approver has already been selected.",
                showConfirmButton: false,
                showCloseButton: true,
            });

        }else{
            validation.handleChange(inputName)(inputValue);
        }
    };

    const LoadDataRequest = (id) => {
        let url = ConfigData.API_URL + "request/" + id ;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const objData = {
                    "id": respData.data[0].id,
                    "request_no": respData.data[0].request_no,
                    "select_legal_approve_by": respData.data[0].select_legal_approve_by,
                    "legal1_approve_by": respData.data[0].legal1_approve_by,
                    "legal2_approve_by": respData.data[0].legal2_approve_by,
                    "legal3_approve_by": respData.data[0].legal3_approve_by,
                    "select_user_approve_by": respData.data[0].select_user_approve_by,
                    "user1_approve_by": respData.data[0].user1_approve_by,
                    "user2_approve_by": respData.data[0].user2_approve_by,
                    "user3_approve_by": respData.data[0].user3_approve_by,
                    "send_to": respData.data[0].legal1_approve_by,
                    "note": ""
                };
                LoadDataReqWorkflowStatus(respData.data[0].id, 17, objData);
                setDataRequestDetail(respData.data[0]);
                if( respData.data[0].table_name?.toLowerCase() === "csa" ){
                    LoadDataRequestForm(respData.data[0].id, "csa");
                } else if( respData.data[0].table_name?.toLowerCase() === "nda" ){
                    LoadDataRequestForm(respData.data[0].id, "nda");
                } else if( respData.data[0].table_name?.toLowerCase() === "ldr" ){
                    LoadDataRequestForm(respData.data[0].id, "ldr");
                } else if( respData.data[0].table_name?.toLowerCase() === "dbd" ){
                    LoadDataRequestForm(respData.data[0].id, "dbd");
                } else if( respData.data[0].table_name?.toLowerCase() === "poa" ){
                    LoadDataRequestForm(respData.data[0].id, "poa");
                }
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };
    
    const LoadDataReqWorkflowStatus = (idReq, idWorkflowStatus, objReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq  + "&idWorkflowStatus=" + idWorkflowStatus;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                objReq.note = respData.data[0].comment;
            }
            setDataRequest(objReq);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
            setDataRequest(objReq);
        });
    };

    const LoadRequestHistory = (idReq) => {
        let url = ConfigData.API_URL + "request-workflow/search?status=1&idRequest=" + idReq;
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, {
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token,
            },responseType: "json",
        }).then((resp) => {
            const respData = resp.data;
            if (respData.is_sucess && respData.data.length > 0) {
                setDataRequestHistory(respData.data);
            }
        }).catch((error) => {
            console.log(error);
        });
    };

    const LoadDataRequestForm = (idRequests, formName) => {
        let url;
        if( formName === "csa" ){
            url = ConfigData.API_URL + "form-csa/request/" + idRequests;
        } else if( formName === "nda" ){
            url = ConfigData.API_URL + "form-nda/request/" + idRequests;
        } else if( formName === "ldr" ){
            url = ConfigData.API_URL + "form-ldr/request/" + idRequests;
        } else if( formName === "dbd" ){
            url = ConfigData.API_URL + "form-dbd/request/" + idRequests;
        } else if( formName === "poa" ){
            url = ConfigData.API_URL + "form-poa/request/" + idRequests;
        }

        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrData = respData.data[0];
                setDataRequestFormDetail(arrData);
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const LoadUserCanDoReq = (id) => {
        let userDo = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let url = new URL(ConfigData.API_URL + "request/user-can-do");
        url.searchParams.set("email", userDo);
        url.searchParams.set("id-request", id);
        url.searchParams.set("id-workflow", "16"); 
        let token = "Bearer " + localStorage.getItem("tkd");
        axios.get(url, { headers: { 
            'Authorization' : token ,
        }, responseType: "json" })
        .then(resp => {
            let respData = resp.data;
            if(respData.is_sucess === true && respData.data.length > 0){
                const arrUserDo = respData.data[0].user_do_request.split(",");
                if(arrUserDo.find((e) => e === userDo) !== undefined){
                    LoadDataRequest(id);    
                    LoadRequestHistory(id); 
                }else{
                    history.push("/summary-request/" + btoa(id));
                }
            }else{
                // history.push("/dashboard");
                history.push(GetUrlBack());
            }
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    const SavePreFinalContactUser = (values) => {
        if(values.id > 0){
            showLoading(true);
            let isSaveSucess = true;
            (async () => {
                let isSaveFinalContractUser = await UpdateFinalContractUser(values);
                isSaveSucess = (isSaveFinalContractUser === true && isSaveSucess === true) ? true : false;
                let isSaveReqWorkflowStatus = await AddWorkFlowStaus(values);
                isSaveSucess = (isSaveReqWorkflowStatus === true && isSaveSucess === true) ? true : false;
                if(isSaveSucess === true){
                    SendEmail(values);
                    showLoading(false);
                    Swal.fire({
                        iconHtml: IconAlertSuccess,
                        title: "ส่งคำขอเรียบร้อย\nอยู่ระหว่างส่งคำขอสุดท้ายให้ผู้อนุมัติขั้นสุดท้าย\nSubmitted the request\nsending to final approvers",
                        showConfirmButton: false,
                        showCloseButton: true,
                    }).then(() => {
                        // history.push("/dashboard");
                        history.push(GetUrlBack());
                    });
                }else{
                    showLoading(false);
                }
            })();
        }
    };

    const UpdateFinalContractUser = async (dataReq) => {
        const url = ConfigData.API_URL + "request/prefilnal-by-user/" + dataReq.id;
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        dataReq.select_user_approve_by = userId;
        try{
            const resp = await axios.put(url, dataReq, { headers: { 
                'Authorization' : token,
                'User': userId,
            }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }

    };

    const AddWorkFlowStaus = async (dataReq) => {
        const url = ConfigData.API_URL + "request-workflow/step";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        try{
            let formData = new FormData();
            formData.append("id_request", dataReq.id);
            formData.append("id_workflow_status", "17");
            formData.append("do_by", userId);
            formData.append("send_to", dataReq.send_to);
            formData.append("comment", dataReq.note);
            const resp = await axios.post(url, formData, { headers: { 
                            'Authorization' : token,
                            'User': userId,
                        }, responseType: "json" });
            let respData = resp.data;
            return respData.is_sucess;
        }catch(error){
            console.log(error);
            return false;
        }
    };

    const SendEmail = (data) => {
        const url = ConfigData.API_URL + "email/send";
        const token = "Bearer " + localStorage.getItem("tkd");
        const userId = (!localStorage.getItem("emd")) ? "" : atob(localStorage.getItem("emd"));
        let arrTo = data.send_to.split(",");
        let dataReq = {
            "to": arrTo,
            "template_id": 12,
            "request_id": data.id,
        };
        axios.post(url, dataReq, { headers: { 
            'Authorization' : token,
            'User': userId,
        }, responseType: "json" })
        .then(resp => {
            // console.log(resp.data);
        })
        .catch(error => {
            // handlerRespError(error, history);
            console.log(error);
        });
    };

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="prefinal-contract-user">
                    <Row>
                        <Col lg={12}>
                            <p className="pcu-title">Request Detail {"> " + dataRequest.request_no}</p>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={12}>
                            <StepWorkflow step={7} />
                        </Col>
                    </Row>
                    <Nav tabs className="nav nav-tabs nav-tabs-form nav-justified mb-3">
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "1",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("1");
                                }}
                            >
                                Request Form
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "2",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("2");
                                }}
                            >
                                Work Area
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                style={{ cursor: "pointer" }}
                                className={classnames({
                                    active: customActiveTab === "3",
                                })}
                                onClick={() => {
                                    toggleCustomActiveTab("3");
                                }}
                            >
                                History
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent
                        activeTab={customActiveTab}
                    >
                        <TabPane tabId="1">
                            {SwitchRequestDetail()}
                        </TabPane>
                        <TabPane tabId="2">
                            <Row className="justify-content-center">
                                <Col sm={12} md={8} lg={6}>
                                    <Form className="needs-validation"
                                        onSubmit={(e) => {
                                            e.preventDefault();
                                            validation.handleSubmit();
                                            return false;
                                        }}
                                    >
                                        <Row className="pcu-legal-div">
                                            <Col lg={12}>
                                                <p className="pcu-legal-title">ฝ่ายกฏหมายได้เลือกผู้อนุมัติขั้นตอนสุดท้าย<br/>(Legal team selected final approver(s)</p>
                                                <p className="pcu-legal-desc">เพื่ออนุมัติตามลำดับ ดังนี้ (with the following approval sequence.)</p>
                                                {(dataRequest.legal1_approve_by !== "") ? <p className="pcu-legal-user">1.{dataRequest.legal1_approve_by}</p> : null}
                                                {(dataRequest.legal2_approve_by !== "") ? <p className="pcu-legal-user">2.{dataRequest.legal2_approve_by}</p> : null}
                                                {(dataRequest.legal3_approve_by !== "") ? <p className="pcu-legal-user">3.{dataRequest.legal3_approve_by}</p> : null}
                                                <div className="pcu-legal-remark">
                                                    <p className="pcu-legal-remark-title">
                                                        <i className="mdi mdi-alert"></i>
                                                        หมายเหตุ (Remark)
                                                    </p>
                                                    <p className="pcu-legal-remark-desc">
                                                        ผู้ทำคำขอมีหน้าที่ในการส่งเอกสารที่ลงนามแล้ว ให้แก่บุคคลหรือฝ่ายที่เกี่ยวข้อง เช่น แผนกบัญชี หรือ การเงิน
                                                        <br/>Please note that user is responsible for sending the signed document(s) to related party
                                                        <br/>or related department (such as accounting or finance team.)
                                                    </p>
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <p className="pcu-form-header">ท่านสามารถเลือกผู้อนุมัติขั้นสุดท้ายเพิ่มเติมได้<br/>You can select additional final approval</p>
                                                <p className="pcu-form-title">
                                                    ท่านสามารถเลือกผู้อนุมัติได้ 1-3 คน โดยการอนุมัติจะถูกเรียงตามลำดับที่ท่านเลือก<br/>
                                                    (You can select 1-3 persons.The approval will be arranged according to your selection.)
                                                </p>
                                                <FormGroup>
                                                    <Label className="pcu-form-label" htmlFor="txtApprove1">1.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย(ถ้ามี) (Require Final Approval From(If any)</Label>
                                                    <Input id="txtApprove1" 
                                                        name="user1_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.user1_approve_by || ""}
                                                        invalid={ validation.touched.user1_approve_by && validation.errors.user1_approve_by ? true : false }    
                                                    />
                                                    { validation.touched.user1_approve_by && validation.errors.user1_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.user1_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcu-form-label" htmlFor="txtApprove2">2.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย(ถ้ามี) (Require Final Approval From(If any)</Label>
                                                    <Input id="txtApprove2" 
                                                        name="user2_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.user2_approve_by || ""}
                                                        invalid={ validation.touched.user2_approve_by && validation.errors.user2_approve_by ? true : false } 
                                                    />
                                                    { validation.touched.user2_approve_by && validation.errors.user2_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.user2_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcu-form-label" htmlFor="txtApprove3">3.จำเป็นต้องได้รับการอนุมัติขั้นสุดท้ายโดย(ถ้ามี) (Require Final Approval From(If any)</Label>
                                                    <Input id="txtApprove3" 
                                                        name="user3_approve_by"
                                                        placeholder="Please Input email"
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            // validation.handleChange(e);
                                                            SetAndCheckEmail(e.target.value, e.target.name);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.user3_approve_by || ""}
                                                        invalid={ validation.touched.user3_approve_by && validation.errors.user3_approve_by ? true : false }
                                                    />
                                                    { validation.touched.user3_approve_by && validation.errors.user3_approve_by ? 
                                                        ( <FormFeedback type="invalid">{validation.errors.user3_approve_by}</FormFeedback> ) : false 
                                                    }
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Row className="pcu-note-div">
                                            <Col lg={12}>
                                                <FormGroup>
                                                    <Label className="pcu-form-label" htmlFor="txtNote">Note</Label>
                                                    <Input id="txtNote"
                                                        name="note"
                                                        placeholder="Note"
                                                        type="textarea"
                                                        rows={1}
                                                        className="from-control"
                                                        onChange={(e) => {
                                                            validation.handleChange(e);
                                                            setFormIsDisabled(false);
                                                        }}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.note || ""}
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </Form>
                                </Col>
                            </Row>
                        </TabPane>
                        <TabPane tabId="3">
                            <Row>
                                <Col md={12}>
                                    <div className="work-area-container-tab">
                                        <div className="header-container header-content">History</div>
                                        <div className="history-container">
                                            <RequestHistory
                                                data={dataRequestHistory}
                                                column="do_date"
                                                requestNo={dataRequestDetail.request_no}
                                            />
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </TabPane>
                        <div className="page-footer">
                            <div className="layout-width-footer">
                                <div className="navbar-footer2">
                                    <Button type="button" className="pcu-btn-back" onClick={(e) => { OnClickBack(); }}>
                                        Back
                                    </Button>
                                    <Button type="button" 
                                        color='primary' 
                                        className="pcu-btn-submit" 
                                        onClick={() => validation.submitForm()}
                                        disabled={formIsDisabled || customActiveTab !== "2"}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </TabContent>
                    
                </Container>
            </div>
        </React.Fragment>
    );
};

export default PrefinalContractUser;